import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('MatchTable')
export class MatchTable {

  @JsonProperty('match_table_id', Number)
  matchTableId: number = 0;

  @JsonProperty('name', String)
  name: string = '';

  @JsonProperty('level_minimum_required', Number)
  levelMinimumRequired: number = 0;

  @JsonProperty('level_experience_reward_quantity', Number)
  levelExperienceRewardQuantity: number = 0;

  @JsonProperty('league_point_reward_quantity', Number)
  leaguePointRewardQuantity: number = 0;

  @JsonProperty('league_point_reward_quantity_2', Number)
  leaguePointRewardQuantity2: number = 0;

  @JsonProperty('hammer_reward_quantity', Number)
  hammerRewardQuantity: number = 0;

  @JsonProperty('credit_reward_quantity_1', Number)
  creditRewardQuantity1: number = 0;

  @JsonProperty('credit_reward_quantity_2', Number)
  creditRewardQuantity2: number = 0;

  @JsonProperty('credit_reward_quantity_draw', Number)
  creditRewardQuantityDraw: number = 0;

  @JsonProperty('match_cost', Number)
  matchCost: number = 0;

  @JsonProperty('match_rank', Number)
  matchRank: number = 0;

  @JsonProperty('variant_id', Number)
  variantId: number = 0;
}
